module.exports = __webpack_public_path__ + "img/Dominica.85e0f650.svg";